import styled from "styled-components";
import { mq } from "./util/media";

const Wrapper = styled.section`
  /* padding-top: 200px; // for header
  ${mq.lt.md} {
    padding-top: 100px;
  } */
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;

  ${props => props.smaller && `
    max-width: 1200px;
  `}
  margin: 0 auto;
`

function SectionWrapper(props) {


  return (

    <Wrapper smaller={props.smaller}>
        {props.children}
    </Wrapper>

  )
}

export default SectionWrapper